import React, { useContext, useEffect, useState } from "react";
import "./TrakingDetails.scss";
import CloseIcon from "@mui/icons-material/Close";
import Delivered from "../../../../../assets/images/Delivered.png";
import RoundCircle from "../../../../../assets/images/circle-img.png";
// import itemImg from "../../../../assets/images/order-items-list.png";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import * as queries from "../../../../../operations/queries";
import * as mutations from "../../../../../operations/mutations";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import { CountryContext } from "../../../MainComponent";
import { useTranslation } from "react-i18next";
import AddReviewModal from "./reviewmodal/AddReviewModal";
import Loader from "../../loader/Loader";
import { Step, StepLabel, Stepper, Typography } from "@mui/material";
import englishCar from "../../../../../assets/images/englishCar.png";
import arabicCar from "../../../../../assets/images/arabicCar.png";
import checkIcon from "../../../../../assets/images/checkCircle.png";
import uncheckIcon from "../../../../../assets/images/uncheckCircle.png";
import cancleIcon from "../../../../../assets/images/cancleIcon.png";

const TrakingDetails = () => {
  const [showAddReviewModal, setShowAddReviewModal] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const idFromUrl = Number(urlParams.get("id"));
  const [modalTitle, setModalTitle] = useState("");
  const { orderNumber } = useParams();
  const loggedInToken = localStorage.getItem("loggedInCust");
  const navigate = useNavigate();
  const { store } = useContext(CountryContext);
  const { t } = useTranslation();
  const afterDelivery = ["delivered", "return", "refund"];
  const returnArray = ["delivered"];

  const { data: orderDetailsRes, refetch :refetchOrderDetails , loading } = useQuery(
    queries.customerQueries.GET_ORDER_DETAILS,
    {
      variables: {
        order_number: orderNumber,
        item_id: idFromUrl,
      },
      fetchPolicy:"network-only",
      context: {
        headers: {
          Authorization: loggedInToken
            ? `Bearer ${JSON.parse(loggedInToken)}`
            : "",
          Connection: "keep-alive",
          store:store,
        },
      },
    }
  );

  const productName = orderDetailsRes?.customerOrdersDetail?.[0]?.product_name;

  const urlKey = productName
    ? productName.toLowerCase().replace(/\s+/g, "-")
    : "";

  const { data: ratingsData, refetch: refetchratingsData } = useQuery(
    queries.ratingQueries.GET_RATINGS_METADATA,
    {
      variables: { url_key: urlKey && urlKey[0] },
      context: {
        headers: {
          Authorization: loggedInToken
            ? `Bearer ${JSON.parse(loggedInToken)}`
            : "",
          Connection: "keep-alive",
          store: store,
        },
      },
    }
  );

  const [createProductReview] = useMutation(
    mutations.createProductReview.CREATE_PRODUCT_REVIEW,
    {
      context: {
        headers: {
          Authorization: loggedInToken
            ? `Bearer ${JSON.parse(loggedInToken)}`
            : "",
          Connection: "keep-alive",
          store: store,
        },
      },
    }
  );

  useEffect(() => {
    refetchratingsData();
    refetchOrderDetails()
    //eslint-disable-next-line
  }, [orderDetailsRes,store]);

  const ratingMetaDataId =
    ratingsData?.productReviewRatingsMetadata?.items?.[0]?.id;

  const ratingMetadata = () => {
    if (ratingsData?.productReviewRatingsMetadata?.items?.[0]?.values) {
      return ratingsData?.productReviewRatingsMetadata?.items?.[0]?.values;
    } else {
      return [];
    }
  };

  const orderDetails = orderDetailsRes?.customerOrdersDetail?.[0] || [];
  // const { order_date, status, total, shipping_address[0] } = orderDetails;

  const closePage = () => {
    const currentPath = window.location.pathname;
    const basePath = currentPath.split("/tracking")[0];
    navigate(basePath);
  };

  const orderDetailsPage = () => {
    const currentPath = window.location.pathname;
    const basePath = currentPath.split("/tracking")[0];
    const orderLink = `${basePath}/order/${orderNumber}?id=${idFromUrl}`;
    navigate(orderLink);
  };

  const orderReturnPage = () => {
    const currentPath = window.location.pathname;
    const basePath = currentPath.split("/tracking")[0];
    const orderLink = `${basePath}/return-order/${orderNumber}?id=${idFromUrl}`;
    navigate(orderLink);
  };

  const handleAddReviewOpen = (title: string) => {
    setModalTitle(title);
    setShowAddReviewModal(true);
  };

  const handleAddReviewClose = () => {
    setShowAddReviewModal(false);
  };

  const handleSubmit = async (reviewData: any) => {
    // handleAddReviewClose();
    try {
      // eslint-disable-next-line
      const { data } = await createProductReview({
        variables: {
          input: {
            ...reviewData,
          },
        },
      });

      handleAddReviewClose();
    } catch (error) {
      console.error("Error creating product review:", error);
    }
  };

  const steps = [
    { label: t("buyer_dashboard.OrderTracking.step_lable_1"), value: "pending" },
    { label: t("buyer_dashboard.OrderTracking.step_lable_2"), value: "confirmed" },
    { label: t("buyer_dashboard.OrderTracking.step_lable_3"), value: "canceled" },
    { label: t("buyer_dashboard.OrderTracking.step_lable_4"), value: "processing" },
    { label: t("buyer_dashboard.OrderTracking.step_lable_5"), value: "out_for_delivery" },
    { label: t("buyer_dashboard.OrderTracking.step_lable_6"), value: "lost_order" },
    { label: t("buyer_dashboard.OrderTracking.step_lable_7"), value: "delivered" },
  ];

  const getVisibleSteps = (status: any) => {
    return steps?.filter((step) => {
      if (status === "canceled") {
        return (
          step.value !== "confirmed" &&
          step.value !== "delivered" &&
          step.value !== "out_for_delivery" &&
          step.value !== "processing" &&
          step.value !== "lost_order"
        );
      } else if (status === "lost") {
        return (
          step.value !== "canceled" &&
          step.value !== "out_for_delivery" &&
          step.value !== "delivered"
        );
      }  else {
        return step.value !== "canceled" && step.value !== "lost_order";
      }
    });
  };

  const visibleSteps = getVisibleSteps(orderDetails?.status);

  const mapStatusToStepValue = (status: any) => {
    switch (status?.toLowerCase()) {
      case "placed":
      case "pending":
        return "pending";
      case "accepted":
        return "confirmed";
      case "canceled":
        return "canceled";
      case "processing":
      case "awb_generated":
      case "onhold":
        return "processing";
      case "lost":
        return "lost_order";
      case "shipped":
        return "out_for_delivery";
      case "delivered":
        return "delivered";
      default:
        return "pending";
    }
  };

  const activeStep = visibleSteps?.findIndex(
    (step) => step?.value === mapStatusToStepValue(orderDetails?.status)
  );

  return (
    <>
      <div className="tracking-details-main-box">
        <div className="tracking-heder">
          <div className="title">
            <h4>{t("buyer_dashboard.OrderTracking.title")} </h4>

            <p>{t("buyer_dashboard.OrderTracking.desc")}</p>
          </div>

          <div className="close-btn">
            <button onClick={() => closePage()}>
              <CloseIcon />
            </button>
          </div>
        </div>

        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="tracking-body">
              <div className="tracking-details">
                <div className="delivered-box">
                  <img src={Delivered} alt="Icon" />
                  <h5>
                    <span>
                      {orderDetails?.status?.charAt(0)?.toUpperCase()}
                      {orderDetails?.status?.slice(1)}
                    </span>{" "}
                    on{" "}
                    {new Date(orderDetails?.date)?.toLocaleDateString("en-GB")}{" "}
                    at {new Date(orderDetails?.date)?.toLocaleTimeString()}
                  </h5>
                </div>
                {afterDelivery.includes(orderDetails?.status) && (
                  <div className="tracking-shopping-experience">
                    <div className="title">
                      <h6>{t("buyer_dashboard.OrderTracking.experience")}</h6>

                      <p>
                        {orderDetails.status.charAt(0).toUpperCase()}
                        {orderDetails.status.slice(1)}
                      </p>
                    </div>

                    <div className="feedbacks-box-grp">
                      <div className="feedback-grp">
                        <img src={RoundCircle} alt="Icon" />
                        <p>
                          {t("buyer_dashboard.OrderTracking.seller_feedback")}
                        </p>
                        <button
                          onClick={() => handleAddReviewOpen("REVIEW SELLER")}
                        >
                          {t("buyer_dashboard.OrderTracking.seller_review")}
                        </button>
                      </div>

                      <div className="feedback-grp">
                        <img src={RoundCircle} alt="Icon" />
                        <p>
                          {t("buyer_dashboard.OrderTracking.product_feedback")}
                        </p>
                        <button
                          onClick={() => handleAddReviewOpen("REVIEW PRODUCT")}
                        >
                          {t("buyer_dashboard.OrderTracking.product_review")}
                        </button>
                      </div>

                      <div className="feedback-grp">
                        <img src={RoundCircle} alt="Icon" />
                        <p>
                          {t("buyer_dashboard.OrderTracking.delivery_feedback")}
                        </p>
                        <button
                          onClick={() => handleAddReviewOpen("REVIEW DELIVERY")}
                        >
                          {t("buyer_dashboard.OrderTracking.delivery_review")}
                        </button>
                      </div>

                      <AddReviewModal
                        open={showAddReviewModal}
                        onClose={handleAddReviewClose}
                        onSubmit={handleSubmit}
                        detailsData={orderDetails}
                        ratingMetadata={ratingMetadata()}
                        ratingMetaDataId={ratingMetaDataId}
                        title={modalTitle}
                      />
                    </div>
                  </div>
                )}
                <div className="tracking-item-summary">
                  <div className="title">
                    <h5>{t("buyer_dashboard.OrderTracking.item_summary")}</h5>
                  </div>
                  <div className="details">
                    {/* eslint-disable-next-line */}
                    <img
                      src={orderDetails?.product_image}
                      alt="Image"
                      style={{ maxWidth: "15%" }}
                    />
                    <div>
                      <p>{orderDetails.product_name}</p>
                      <h4>
                        {orderDetails.currency} {orderDetails.price}
                      </h4>
                    </div>
                  </div>
                </div>

                <div className="order-stepper">
                  <div className="order-code-coform-btn-grp">
                    <p color="text.primary">{orderDetails?.order_number}</p>
                    {/* <Button
                      variant="contained"
                      className="stepper-status-btn"
                      size="small"
                    >
                      Confirmed
                    </Button> */}
                  </div>

                  <Stepper
                    alternativeLabel
                    activeStep={activeStep}
                    className={`custom-stepper for-web`}
                  >
                    {visibleSteps?.map((step, index) => (
                      <Step key={index}>
                        <StepLabel
                          icon={
                            index < activeStep ? (
                              <img
                                src={checkIcon}
                                alt="checkIcon"
                                style={{
                                  marginTop: "3px",
                                  zIndex: 25,
                                  height: "36px",
                                }}
                              />
                            ) : index === activeStep ? (
                              <>
                                {(orderDetails?.status === "canceled" || orderDetails?.status === "lost") ? (
                                  <img
                                    src={cancleIcon}
                                    alt="checkIcon"
                                    style={{
                                      marginTop: "3px",
                                      zIndex: 25,
                                      height: "36px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={checkIcon}
                                    alt="checkIcon"
                                    style={{
                                      marginTop: "3px",
                                      zIndex: 25,
                                      height: "36px",
                                    }}
                                  />
                                )}
                                {orderDetails?.status !== "canceled" &&
                                orderDetails?.status !== "lost" &&
                                  orderDetails?.status !== "delivered" && (
                                    <img
                                      src={
                                        store.includes("ar")
                                          ? arabicCar
                                          : englishCar
                                      }
                                      alt="Tracking icon"
                                      style={{ marginBottom: "18px" }}
                                      className="carIcon"
                                    />
                                  )}
                              </>
                            ) : (
                              <img
                                src={uncheckIcon}
                                alt="uncheckIcon"
                                style={{
                                  marginTop: "3px",
                                  zIndex: 25,
                                  height: "32px",
                                }}
                              />
                            )
                          }
                          className={
                            index <= activeStep ? "completed" : "pending"
                          }
                        >
                          <p className="title">{step.label}</p>
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>

                  <Stepper
                    alternativeLabel
                    activeStep={activeStep}
                    orientation="vertical"
                    className="custom-stepper for-mobile"
                  >
                    {visibleSteps?.map((step, index) => (
                      <Step key={index}>
                        <StepLabel
                          icon={
                            index < activeStep ? (
                              <img
                                src={checkIcon}
                                alt="checkIcon"
                                style={{
                                  marginTop: "3px",
                                  zIndex: 25,
                                  height: "36px",
                                }}
                              />
                            ) : index === activeStep ? (
                              <>
                                {(orderDetails?.status === "canceled" || orderDetails?.status === "lost") ? (
                                  <img
                                    src={cancleIcon}
                                    alt="checkIcon"
                                    style={{
                                      marginTop: "3px",
                                      zIndex: 25,
                                      height: "36px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={checkIcon}
                                    alt="checkIcon"
                                    style={{
                                      marginTop: "3px",
                                      zIndex: 25,
                                      height: "36px",
                                    }}
                                  />
                                )}
                              </>
                            ) : (
                              <img
                                src={uncheckIcon}
                                alt="uncheckIcon"
                                style={{
                                  marginTop: "3px",
                                  zIndex: 25,
                                  height: "32px",
                                }}
                              />
                            )
                          }
                          className={
                            index <= activeStep ? "completed" : "pending"
                          }
                        >
                          <p className="title">{step.label}</p>
                          {/* <p className="date-time">{`${step.date}`}</p>
                          <p className="date-time">{`${step.time}`}</p> */}
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    style={{ color: "#201010" }}
                    mt={2}
                  >
                    {t("buyer_dashboard.OrderTracking.steper_sort_desc")}{" "}
                    {orderDetails?.status?.charAt(0)?.toUpperCase()}
                    {orderDetails?.status?.slice(1)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                  {t("buyer_dashboard.OrderTracking.jebelz_tech")}
                  </Typography>
                </div>
              </div>

              <div className="tracking-summary-details">
                <div className="tracking-delivery-address">
                  <h5>{t("buyer_dashboard.OrderTracking.Delivery_address")}</h5>
                  <p>
                    {orderDetails?.shipping_address?.[0]?.firstname}{" "}
                    {orderDetails?.shipping_address?.[0]?.lastname}
                    <br />
                    {orderDetails?.shipping_address?.[0]?.street},{" "}
                    {orderDetails?.shipping_address?.[0]?.city},{" "}
                    {orderDetails?.shipping_address?.[0]?.region}
                    <br />
                  </p>
                  <h6>
                    {" "}
                    {orderDetails?.shipping_address?.[0]?.telephone}{" "}
                    <span className="verified" style={{ color: "green" }}>
                      {t("buyer_dashboard.OrderTracking.Verified")}
                    </span>
                  </h6>
                </div>
                <div className="tracking-invoice-summary">
                  <div>
                    <h5>
                      {t("buyer_dashboard.OrderTracking.download_invoice")}
                    </h5>
                    <p>
                      {t("buyer_dashboard.OrderTracking.download_invoice_desc")}
                    </p>
                  </div>

                  <button onClick={() => orderDetailsPage()}>
                    <ArrowForwardIosIcon />
                  </button>
                </div>

                {returnArray.includes(orderDetails?.status) && (
                  <>
                    {(() => {
                      const refundDate = new Date(orderDetails?.date);
                      const currentDate = new Date();
                      const diffTime = Math.abs(
                        currentDate.getTime() - refundDate.getTime()
                      );
                      const diffDays = diffTime / (1000 * 60 * 60 * 24);

                      const returnEndDate = new Date(refundDate);
                      returnEndDate.setDate(refundDate.getDate() + 7);

                      return diffDays <= 7 ? (
                        <div className="tracking-invoice-summary">
                          <div>
                            <h5>
                              {" "}
                              {t("buyer_dashboard.OrderTracking.return_order")}
                            </h5>
                            <p>
                              {" "}
                              {t(
                                "buyer_dashboard.OrderTracking.return_order_desc"
                              )}
                            </p>
                          </div>

                          <button onClick={() => orderReturnPage()}>
                            <ArrowForwardIosIcon />
                          </button>
                        </div>
                      ) : null;
                    })()}
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default TrakingDetails;
